<template>
  <ul class="list-group border border-light2">
    <draggable
        :list="inputObjArr"
        itemKey="ident"
        handle=".move"
        ghost-class="ghost"
    >
      <template #item="{ index, element }">
        <li
            class="list-group-item px-0 px-md-3 border-0"
        >
          <span class="fw-bold text-secondary ms-1 ms-md-0">
            {{getTitle(element.ident)}}
          </span>
          <span class="right-top-btns">
              <span
                  class="btn"
              >
                <label
                    class="form-check-label"
                    :title="$t('parameter.form.btn.visibility.hint')"
                >
                  <input
                      v-model="element.isPublic"
                      class="form-check-input"
                      type="checkbox"

                  />
                  {{ $t('parameter.form.btn.visibility.title') }}
                </label>
              </span>


              <span
                  @click.prevent="removeItem(index, element.ident)"
                  class="btn btn-outline"
                  :title="$t('parameter.form.btn.remove.hint')"
              >
                <i class="bi bi-trash"></i>
                <!-- &nbsp;Odstranit-->

              </span>
            <!--
              <span
                  v-if="Object.keys(inputModel).length > 1"
                  class="move btn btn-outline"
                  :title="$t('parameter.form.btn.move.hint')"
              >
                <i class="bi bi-arrows-move"></i>
              </span>
              -->
            </span>

          <div>

            <template
                v-if="getType(element.ident) === 'varchar'"
            >
              <input
                  v-model="element.value"
                  type="text"
                  class="form-control"
                  :placeholder="$t('parameter.form.placeholder')"
              />
            </template>

            <template
                v-else-if="getType(element.ident) === 'textlong'"
            >
                <textarea
                    v-model="element.value"
                    class="form-control"
                    :placeholder="$t('parameter.form.placeholder')"
                >
                </textarea>
            </template>

            <template
                v-else-if="getType(element.ident) === 'bool'"
            >
              <div class="form-check form-switch">
                <label class="form-check-label">
                  <input
                      v-model="element.value"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                  >
                  <span
                      v-if="element.value"
                  >
                      {{ $t('parameter.form.input.bool.true.value') }}
                    </span>
                  <span
                      v-else
                  >
                      {{ $t('parameter.form.input.bool.false.value') }}
                    </span>
                </label>
              </div>

              <!--
                              <div class="form-check form-check-inline">
                                <label
                                    class="form-check-label"
                                >
                                  <input
                                      type="radio"
                                      v-model="element.value"
                                      :value="true"
                                  >
                                  {{ $t('parameter.form.input.bool.true.value') }}
                                </label>
                              </div>

                              <div class="form-check form-check-inline">
                                <label
                                    class="form-check-label"
                                >
                                  <input
                                      type="radio"
                                      v-model="element.value"
                                      :value="false"
                                  >
                                  {{ $t('parameter.form.input.bool.false.value') }}
                                </label>
                              </div>
                -->

            </template>

            <template
                v-else-if="getType(element.ident) === 'select'"
            >
              <select
                  v-model="element.value"
                  class="form-select"
              >
                <option
                    v-for="(item, i) in getSelectFill(element.ident)"
                    :value="item.id"
                >
                  {{item.title}}
                </option>

              </select>
            </template>

            <template
                v-else-if="getType(element.ident) === 'radio'"
            >

              <template
                  v-for="(item, i) in getSelectFill(element.ident)"
              >
                <div class="form-check form-check-inline">
                  <label
                      class="form-check-label"
                  >
                    <input
                        type="radio"
                        v-model="element.value"
                        :value="item.id"
                    >
                    {{ item.title}}
                  </label>
                </div>
              </template>
            </template>

            <template
                v-else
            >
              [ELSE] {{getType(element.ident)}}
            </template>
          </div>
        </li>
      </template>
    </draggable>
  </ul>

<!--
  <display-debug>
    <template #debugView>
      inputObjArr: {{  inputObjArr}}
    </template>
  </display-debug>
  <display-debug>
    <template #debugView>
      inputModel: {{  inputModel}}
    </template>
  </display-debug>
  -->
  <div
      v-if="types && Object.entries(types).length > 0"
      class="mt-2"
  >
    <!--
         @update:modelValue="(v) => updatePropertyList(v)"
    -->
    <multiselect
        @update:modelValue="(v) => picked(v)"
        :options="types"
        track-by="ident"
        :searchable="true"
        :hideSelected="false"

        label="title"
        :placeholder="$t('parameter.suggest.input_placeholder')"
    >
      <template v-slot:singleLabel="{ option }">
        <div class="d-flex align-items-center">
          <i v-if="option.ico" :class="option.ico+' me-2'"></i>
          <span>{{option.title}}</span>
        </div>
      </template>

      <template v-slot:option="{ option, search }">
        <div class="d-flex align-items-center">
          <i v-if="option.ico" :class="option.ico+' me-2'"></i>
          <span>{{option.title}}</span>
        </div>
      </template>

      <template v-slot:noResult>
        <div class="multiselect--no-results">{{ $t('parameter.suggest.no_results') }}</div>
      </template>

      <template v-slot:noOptions>
        <div class="multiselect--no-results">{{ $t('parameter.suggest.no_results') }}</div>
      </template>
    </multiselect>
  </div>
<!--
     <display-debug>
       <template #debugView>inputModel {{inputObj}}</template>
    </display-debug>
  -->
</template>

<script>

import multiselect from "vue-multiselect";
import draggable from "vuedraggable";

export default {
  name: "ParametersInput2",
  components: {
    multiselect,
    draggable,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": {
      type: [Object],
      required: false,
      default: null,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      type: {},
      inputModel: {},
    }
  },
  created() {
    if(this.inputObj.val) {
      this.inputModel = this.inputObj.val;
    }
    if(this.inputObj.templates.types) {
      this.updateTypes()
    }
  },
  mounted() {

  },
  computed: {
    inputObjArr() {
      return Object.values(this.inputModel)
    }
  },

  methods: {

    picked(value) {
//, typeof this.inputModel[value.ident]
      if(
          typeof this.inputModel[value.ident] === "undefined"
      ){
        const newItem = {
          ident: value.ident,
          value: null,
          isPublic: true,
        }


        this.inputModel[value.ident] = newItem;

        this.removeType(value.ident)

      }else{
        alert('Tato vlastnost je jiz nastavena')
      }

      // Tady můžeš dělat cokoliv s vybranou hodnotou
    },
    removeType(type) {
      const index = this.types.findIndex(item => item.ident === type)
      if(index >= 0) {
        //teda spis nastav readonly
        //this.types[index].readonly = true
        this.types.splice(index, 1)
      }
    },
    updateTypes() {
      this.types = [...this.inputObj.templates.types];
      if(this.inputModel) {
        for( const i in this.inputModel) {
          if(
              this.inputModel
          ) {
            const index = this.types.findIndex(item => item.ident === i)
            this.types.splice(index, 1)
          }
        }
      }
    },

    removeItem(index, ident = null){
      if (confirm(this.$t('parameter.form.confirm.remove'))) {
        delete this.inputModel[ident];
        this.updateTypes()
      }
    },

    getTitle(ident) {
      const index = this.inputObj.templates.types.findIndex(item => item.ident === ident)
      if(
          index != -1
          && this.inputObj.templates.types[index]
      ) {
        return this.inputObj.templates.types[index].title
      }else{
        return ident
      }
    },

    getParams(ident) {
      const res = this.inputObj.templates.types.find(obj => obj.ident === ident)
      //dev return  res.params;
    },



    getSelectFill(ident) {
      const res = this.inputObj.templates.types.find(obj => obj.ident === ident)
      if(res.select) {
        return  res.select;
      }else{
        return [];
      }
    },

    getType(ident) {
      const res = this.inputObj.templates.types.find(obj => obj.ident === ident)
      return  res.type;
    },

    getDisplayStatus(item, condition) {
      let status = true
      if(typeof condition != "undefined" && condition) {
        for(const index_c in condition) {
          if(
              item[condition[index_c]].value == null
              || item[condition[index_c]].value <= 0
          ) {
            status = false;
          }
        }
      }
      return status
    }
  },
  watch: {
    "inputObj.val": {
      handler(newVal) {
        if(newVal) {
          this.inputModel = newVal;
        }
      },
      deep: true,
      immediate: true
    },

    inputModel: {
      handler(newVal) {
        if(Array.isArray(newVal)) {
          const newVal2 = {}
          for(const i in newVal) {
            newVal2[newVal[i].ident] = newVal[i];
          }
          this.inputModel = newVal2;
        }

        this.$emit('update:modelValue', newVal )
      },
      deep: true,
      immediate: true
    }
  },
};
</script>